import classNames from "classnames";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { useState } from "react";

function Footer({
  title,
  description,
  longDescription,
  to = "https://www.mutuelle-familiale.fr/politique-confidentialite",
  labelLink,
  variant = "center",
  size = "medium",
  type = "normal",
  onClick,
}) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const [expanded, setExpanded] = useState(false);

  const FOOTER = t("B2C_LMF.FOOTER", { returnObjects: true });
  const FOOTER_SIGNATURE = t("B2C_LMF.FOOTER_SIGNATURE", { returnObjects: true });
  const FOOTER_CREATE = t("B2C_LMF.FOOTER_CREATE", { returnObjects: true });
  const SIMPLE = t("B2C_LMF.FOOTER__SIMPLE", { returnObjects: true });

  const isLeft = variant === "left";

  const text = isLeft
    ? type === "signature"
      ? FOOTER_SIGNATURE
      : type === "create"
      ? FOOTER_CREATE
      : FOOTER
    : SIMPLE;

  return (
    <div
      className={classNames("lmf__footer", {
        "lmf__footer--left": isLeft,
        "lmf__footer--center": !isLeft,
        [`lmf__footer--${size}`]: size,
      })}
      onClick={onClick}
    >
      {isLeft && <span className="--title">{title ?? text.TITLE}</span>}

      <div className="lmf__footer--description">
        <p
          dangerouslySetInnerHTML={{ __html: description ?? text.DESC }}
          {...(isLeft && {
            onClick: () => setExpanded(!expanded),
            style: { cursor: "pointer" },
          })}
        />

        {isLeft && expanded && text.CONTENT && (
          <div className="lmf__footer--paragraphs">
            <p dangerouslySetInnerHTML={{ __html: text.CONTENT.DESC_1 }} />
            <p dangerouslySetInnerHTML={{ __html: text.CONTENT.DESC_2 }} />
            <p dangerouslySetInnerHTML={{ __html: text.CONTENT.DESC_3 }} />
            <p dangerouslySetInnerHTML={{ __html: text.CONTENT.DESC_4 }} />
            {text.CONTENT.DESC_5 && (
              <p dangerouslySetInnerHTML={{ __html: text.CONTENT.DESC_5 }} />
            )}
          </div>
        )}
      </div>

      <Link to={to} className="--link" target="_blank" rel="noopener noreferrer">
        {labelLink ?? text.LABEL}
      </Link>
    </div>
  );
}

export default Footer;
